var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.isActive,ref:"translateWrapper"},[(_vm.isActive)?_c('v-google-translate',{staticClass:"translate-wrapper",attrs:{"default-language-code":_vm.$store.getters['language/currentLanguage'] || 'en',"fetchBrowserLanguage":false,"languages":_vm.languages,"trigger":"click"},on:{"select":_vm.handleGoogleTranslateSelect}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }